import { Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { parseString } from 'xml2js';
import { AlertMapService } from 'src/app/main/side-bar/alert/alert-map.service';
import 'src/assets/js/maplibs/Leaflet-WMS.js';
import { isNullOrUndefined } from 'util';
import { AlertMapConstants, MapConstants } from 'src/app/main/side-bar/alert/alert-gis/alert-gis.const';
import { AlertDataService } from 'src/app/main/side-bar/alert/alert-data.service';


@Component({
  selector: 'app-baselayers',
  templateUrl: './baselayers.component.html',
  styleUrls: ['./baselayers.component.scss']
})
export class BaselayersComponent implements OnInit {
@Input() mapObj : any;
@Input() layersList : any;
baseLayerMetaData:any = {};
static baseLayerObjMap: any = {};
static selectedSource: string;
static addedLayer: string;
  constructor(private gisService: AlertMapService,private gisUtils:AlertDataService) { }

  ngOnInit() {
    let activeLayer = null;
    for(const key in this.layersList.baselayers){ 
      let val = this.layersList.baselayers[key];
      if(this.mapObj.hasLayer(val)){
        this.layersList.baselayers[key].options.class = 'card card-maps h-100 active';
        activeLayer = true; 
      }
      else
        this.layersList.baselayers[key].options.class= "card card-maps h-100";
    }
    if(isNullOrUndefined(activeLayer)){
      this.layersList.baselayers[BaselayersComponent.addedLayer].options.class = 'card card-maps h-100 active';
    }
    this.baseLayerMetaData = Object.assign({},this.baseLayerMetaData,this.gisService.setWMSOverlays(this.mapObj,this.gisService.getApplicationBasedLayer(MapConstants.BASELAYER_METADATA_LAYER,'WMS',this.mapObj)));
    this.baseLayerMetaData = this.baseLayerMetaData['BASELAYER_METADATA'];    
  }

  showAndHideLayer(layer,base){
    if(base){
      for (const key in this.layersList.baselayers) {
        if (this.layersList.baselayers.hasOwnProperty(key)) {
          const value = this.layersList.baselayers[key];
          if(value.options.name.includes('Sentinel')){
            this.removeSentinelLayers(value.options.name, value.options.layers);
            this.layersList.baselayers[key].options.visible = false;
            this.layersList.baselayers[key].options.class = 'card card-maps h-100';
          }else if(this.mapObj.hasLayer(value)){
            this.mapObj.removeLayer(value);
          
            this.layersList.baselayers[key].options.visible = false;
            this.layersList.baselayers[key].options.class = 'card card-maps h-100';
          }
        }
      }

      if(layer.options.name.includes('Sentinel')){
        // this.addSentinelLayers(layer, layer.options.name, layer.options.layers, MapConstants.LAYERKEY_SOURCE_MAP[layer.options.name]);
        this.gisService.emitSourceChangeEvent(MapConstants.LAYERKEY_SOURCE_MAP[layer.options.name]);
	BaselayersComponent.addedLayer = layer.options.name;        
	if(BaselayersComponent){
          BaselayersComponent.selectedSource = MapConstants.LAYERKEY_SOURCE_MAP[layer.options.name];
        }
      }else{
        this.mapObj.addLayer(layer);

        if(BaselayersComponent){
          BaselayersComponent.selectedSource = null;
        }
      }
      
      layer.options.visible = true;
      layer.options.class = 'card card-maps h-100 active'

      //base map selection works when we drill-down
      const keys = Object.keys(this.layersList.baselayers);
      const selectedIndex = keys.findIndex(k => this.layersList.baselayers[k].options.name === layer.options.name);
      if (selectedIndex !== -1) {
        localStorage.setItem('selectedBaseMapIndex', String(selectedIndex));
      }
      return;
    }
  }


  addSentinelLayers(layerObj: any, layerKey: string, layerName: string, source: string){
    BaselayersComponent.baseLayerObjMap[layerName] = {};
    if(MapConstants.SOURCE_COORDINATE_MAP[source]){
      for(let coordinate in MapConstants.SOURCE_COORDINATE_MAP[source]){
        if(MapConstants.SOURCE_COORDINATE_MAP[source][coordinate]){
          this.baseLayerMetaData.wmsParams.cql_filter="source='"+source+"'";
          this.gisService.getFeatureInfoForGivenPoint(MapConstants.SOURCE_COORDINATE_MAP[source][coordinate].point, MapConstants.SOURCE_COORDINATE_MAP[source][coordinate].bbox, MapConstants.SOURCE_COORDINATE_MAP[source][coordinate].size, this.baseLayerMetaData).subscribe((res: any) => {
            if (res && res['features'].length>=1 && res['features'][0]['properties']['latest_date'] && res['features'][0]['properties']['latest_date'].split('T').length>0) {
              if(source=='SENTINEL_1'){
                if(coordinate=='0'){
                  BaselayersComponent.baseLayerObjMap[layerName].left = this.gisService.getTimeWmsLayerFromLayerName(layerObj, layerName, res['features'][0]['properties']['latest_date'].split('T')[0]);
                  if(!this.mapObj.hasLayer(BaselayersComponent.baseLayerObjMap[layerName].left))
                    BaselayersComponent.baseLayerObjMap[layerName].left.addTo(this.mapObj);
                }else if(coordinate=='1'){
                  BaselayersComponent.baseLayerObjMap[layerName].right = this.gisService.getTimeWmsLayerFromLayerName(layerObj, layerName, res['features'][0]['properties']['latest_date'].split('T')[0]);
                  if(!this.mapObj.hasLayer(BaselayersComponent.baseLayerObjMap[layerName].right))
                    BaselayersComponent.baseLayerObjMap[layerName].right.addTo(this.mapObj);
                }
              }else if(source=='SENTINEL_2'){
                if(coordinate=='0'){
                  BaselayersComponent.baseLayerObjMap[layerName].left = this.gisService.getTimeWmsLayerFromLayerName(layerObj, layerName, res['features'][0]['properties']['latest_date'].split('T')[0]);
                  BaselayersComponent.baseLayerObjMap[layerName].left.addTo(this.mapObj);
                }else if(coordinate=='1'){
                  BaselayersComponent.baseLayerObjMap[layerName].middle = this.gisService.getTimeWmsLayerFromLayerName(layerObj, layerName, res['features'][0]['properties']['latest_date'].split('T')[0]);
                  BaselayersComponent.baseLayerObjMap[layerName].middle.addTo(this.mapObj);
                }else if(coordinate=='2'){
                  BaselayersComponent.baseLayerObjMap[layerName].right = this.gisService.getTimeWmsLayerFromLayerName(layerObj, layerName, res['features'][0]['properties']['latest_date'].split('T')[0]);
                  BaselayersComponent.baseLayerObjMap[layerName].right.addTo(this.mapObj);
                }
              }
            } 
          });
        }
      }
    }
    
  }

  removeSentinelLayers(layerKey: string, layerName: string){
    if(layerKey == 'Sentinel 1'){
      if(BaselayersComponent.baseLayerObjMap[layerName] && BaselayersComponent.baseLayerObjMap[layerName].left){
        this.mapObj.removeLayer(BaselayersComponent.baseLayerObjMap[layerName].left);
      }
        if(BaselayersComponent.baseLayerObjMap[layerName] && BaselayersComponent.baseLayerObjMap[layerName].right){
        this.mapObj.removeLayer(BaselayersComponent.baseLayerObjMap[layerName].right);
      } 
    }else if(layerKey.includes('Sentinel 2')){
      if(BaselayersComponent.baseLayerObjMap[layerName] && BaselayersComponent.baseLayerObjMap[layerName].left){
        this.mapObj.removeLayer(BaselayersComponent.baseLayerObjMap[layerName].left);
      }
      if(BaselayersComponent.baseLayerObjMap[layerName] && BaselayersComponent.baseLayerObjMap[layerName].right){
        this.mapObj.removeLayer(BaselayersComponent.baseLayerObjMap[layerName].right);
      }
      if(BaselayersComponent.baseLayerObjMap[layerName] && BaselayersComponent.baseLayerObjMap[layerName].middle)
        this.mapObj.removeLayer(BaselayersComponent.baseLayerObjMap[layerName].middle);
    }

  }

}
